import { allTrackers } from "app/services/track/track";

import { createManageIntegrationsTrackingService } from "./factory";

const manageIntegrationsTrackingService = createManageIntegrationsTrackingService(
    allTrackers.dispatchTrackEvent.bind(allTrackers),
);

export default manageIntegrationsTrackingService;
